import { render, staticRenderFns } from "./Inputs.vue?vue&type=template&id=287c9f28&scoped=true"
import script from "./Inputs.vue?vue&type=script&lang=js"
export * from "./Inputs.vue?vue&type=script&lang=js"
import style0 from "./Inputs.vue?vue&type=style&index=0&id=287c9f28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287c9f28",
  null
  
)

export default component.exports